@if (!!this.errorMessage()) {
  <ul>
    <p-message severity="error" variant="simple" size="small"
      >{{ this.errorMessage() }}
    </p-message>
  </ul>
}
